import { Theme } from "@mui/system";
import { memo } from "react";

import { Box } from "@tsp/tsp-frontend-components/mui";

const selectColorByExtension = (theme: Theme, extension: string) => {
  switch (extension) {
    case "pdf": {
      return {
        color: theme.palette.error.contrastText,
        backgroundColor: theme.palette.error.main,
      };
    }
    case "xls": {
      return {
        color: theme.palette.success.contrastText,
        backgroundColor: theme.palette.success.main,
      };
    }
    default: {
      return {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
      };
    }
  }
};

export type ExtensionBadgeProps = {
  extension: string;
};

function ExtensionBadge(props: ExtensionBadgeProps) {
  const { extension } = props;

  return (
    <Box
      sx={(theme) => ({
        ...selectColorByExtension(theme, extension),
        fontWeight: 600,
        lineHeight: 1.6,
        borderRadius: 0.5,
        fontSize: "0.65rem",
        textTransform: "uppercase",
        padding: `0 ${theme.spacing(0.5)}`,
      })}
    >
      {extension}
    </Box>
  );
}

export default memo(ExtensionBadge);
